class OptionsManager {
    openOptions(object) {
        const $parent = $(object).parents('.Toolbar_Group');
        $parent.find('.Options').slideDown(400);
    }
    closeOptions(object) {
        const $parent = $(object).parents('.Toolbar_Group');
        $parent.find('.Options').slideUp(400);
    }
}
const optionsManager = new OptionsManager();
window.optionsManager = optionsManager;
export { OptionsManager, optionsManager };
